import { render, staticRenderFns } from "./Submit1.vue?vue&type=template&id=0f1c2c3e&scoped=true"
import script from "./Submit1.vue?vue&type=script&lang=js"
export * from "./Submit1.vue?vue&type=script&lang=js"
import style0 from "./Submit1.vue?vue&type=style&index=0&id=0f1c2c3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1c2c3e",
  null
  
)

export default component.exports